import { render, staticRenderFns } from "./ViewDeleteDialog.vue?vue&type=template&id=9fe8c8cc&scoped=true"
import script from "./ViewDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./ViewDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./ViewDeleteDialog.vue?vue&type=style&index=0&id=9fe8c8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe8c8cc",
  null
  
)

export default component.exports